<div class="sociogram-upper">
    <div class="measurement-name">
        <h3>Sociogram</h3>
    </div>
    <div class="measurement-question">
        <p id="meas-question">Test</p>
    </div>
</div>

<div class="control">
    <mat-card>
        <mat-card-content>
            <div class="toggle_buttons">
                <mat-slide-toggle (change)="onChange($event)" id="toggle_match" checked>Visa Matchning</mat-slide-toggle> 
                <mat-slide-toggle (change)="onChange($event)" id="toggle_single" checked>Visa Enkla Val</mat-slide-toggle> 
            </div>
        </mat-card-content>
    </mat-card>
</div>

<div *ngIf="visNetworkData">
    <div
        class="network-canvas"
        [visNetwork]="visNetwork"
        [visNetworkData]="visNetworkData"
        [visNetworkOptions]="visNetworkOptions"
        (initialized)="networkInitialized()"
    ></div>
</div> 
